export default "__VITE_ASSET__CBX8jDFJ__"